import { render, staticRenderFns } from "./multi-select-search.vue?vue&type=template&id=c54f4b7c&scoped=true&"
import script from "./multi-select-search.vue?vue&type=script&lang=js&"
export * from "./multi-select-search.vue?vue&type=script&lang=js&"
import style0 from "./multi-select-search.vue?vue&type=style&index=0&id=c54f4b7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54f4b7c",
  null
  
)

component.options.__file = "multi-select-search.vue"
export default component.exports